import { features } from 'process';

export const appConfig = {
  isPreProd: process.env.REACT_APP_IS_PRE_PROD === 'true',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@closer2.io',
  widgetUrl: process.env.REACT_APP_WIDGET_URL || 'http://localhost:3001/static/js/bundle.js',
  landingPageUrl: process.env.REACT_APP_LANDING_PAGE_URL || 'http://localhost:8080',
  graphqlApiUrl: process.env.REACT_APP_GRAPHQL_API_URL || 'http://localhost:4000/graphql',
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000',
  previewSiteUrl: process.env.REACT_APP_PREVIEW_SITE_URL || 'http://localhost:3001/preview',
  rolesNamespace: process.env.REACT_APP_ROLES_NAMESPACE || 'https://closer2.io/roles',
  video: {
    maxFileSize: process.env.MAX_FILE_SIZE
      ? parseInt(process.env.MAX_FILE_SIZE, 10)
      : 15 * 1024 * 1024, // 15 MB,
    maxVideoDuration: process.env.MAX_VIDEO_DURATION
      ? parseInt(process.env.MAX_VIDEO_DURATION, 10)
      : 30, // 30 seconds
  },
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  },
  featureFlags: {
    crmBridgeIntegration: process.env.REACT_APP_FEATURE_FLAG_CRM_BRIDGE_INTEGRATION === 'true',
  },
  crmBridge: {
    apiKey:
      process.env.REACT_APP_CRM_BRIDGE_API_KEY ||
      '7d20f99af3d3b992f429a6ee01c736806d1ed6e9e1396d21ded0e9432503550b',
    apiUrl: process.env.REACT_APP_CRM_BRIDGE_API_URL || 'http://localhost:3331/api/v1',
    widgetScriptEsm:
      process.env.REACT_APP_CRM_BRIDGE_WIDGET_ESM ||
      'http://localhost:3333/build/crm-bridge-widget.esm.js',
    widgetScriptLegacy:
      process.env.REACT_APP_CRM_BRIDGE_WIDGET_LEGACY ||
      'http://localhost:3333/build/crm-bridge-widget.js',
  },
};
